import AvenirNextLTProThin from "./assets/fonts/AvenirNextLTPro-Thin.ttf";
import AvenirNextLTProThinIt from "./assets/fonts/AvenirNextLTPro-ThinIt.ttf";
import AvenirNextLTProLight from "./assets/fonts/AvenirNextLTPro-Light.ttf";
import AvenirNextLTProLightIt from "./assets/fonts/AvenirNextLTPro-LightIt.ttf";
import AvenirNextLTProRegular from "./assets/fonts/AvenirNextLTPro-Regular.ttf";
import AvenirNextLTProMedium from "./assets/fonts/AvenirNextLTPro-Medium.ttf";
import AvenirNextLTProMediumIt from "./assets/fonts/AvenirNextLTPro-MediumIt.ttf";
import AvenirNextLTProDemi from "./assets/fonts/AvenirNextLTPro-Demi.ttf";
import AvenirNextLTProDemiIt from "./assets/fonts/AvenirNextLTPro-DemiIt.ttf";
import AvenirNextLTProHeavy from "./assets/fonts/AvenirNextLTPro-Heavy.ttf";
import AvenirNextLTProHeavyt from "./assets/fonts/AvenirNextLTPro-HeavyIt.ttf";
import AvenirNextLTProUltlt from "./assets/fonts/AvenirNextLTPro-UltLt.ttf";
import AvenirNextLTProUltLtIt from "./assets/fonts/AvenirNextLTPro-UltLtIt.ttf";

export const avenirNextLTProFonts = `
@font-face {
  font-family: "AvenirNextLTPro";
  src: url(${AvenirNextLTProThin}) format("truetype");
  font-weight: 100;
  font-style: normal;
}

@font-face {
  font-family: "AvenirNextLTPro";
  src: url(${AvenirNextLTProThinIt}) format("truetype");
  font-weight: 100;
  font-style: italic;
}

@font-face {
  font-family: "AvenirNextLTPro";
  src: url(${AvenirNextLTProLight}) format("truetype");
  font-weight: 300;
  font-style: normal;
}

@font-face {
  font-family: "AvenirNextLTPro";
  src: url(${AvenirNextLTProLightIt}) format("truetype");
  font-weight: 300;
  font-style: italic;
}

@font-face {
  font-family: "AvenirNextLTPro";
  src: url(${AvenirNextLTProRegular}) format("truetype");
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: "AvenirNextLTPro";
  src: url(${AvenirNextLTProMedium}) format("truetype");
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: "AvenirNextLTPro";
  src: url(${AvenirNextLTProMediumIt}) format("truetype");
  font-weight: 500;
  font-style: italic;
}

@font-face {
  font-family: "AvenirNextLTPro";
  src: url(${AvenirNextLTProDemi}) format("truetype");
  font-weight: 600;
  font-style: normal;
}

@font-face {
  font-family: "AvenirNextLTPro";
  src: url(${AvenirNextLTProDemiIt}) format("truetype");
  font-weight: 600;
  font-style: italic;
}

@font-face {
  font-family: "AvenirNextLTPro";
  src: url(${AvenirNextLTProDemi}) format("truetype");
  font-weight: 700;
  font-style: normal;
}

@font-face {
  font-family: "AvenirNextLTPro";
  src: url(${AvenirNextLTProDemiIt}) format("truetype");
  font-weight: 700;
  font-style: italic;
}

@font-face {
  font-family: "AvenirNextLTPro";
  src: url(${AvenirNextLTProHeavy}) format("truetype");
  font-weight: 800;
  font-style: normal;
}

@font-face {
  font-family: "AvenirNextLTPro";
  src: url(${AvenirNextLTProHeavyt}) format("truetype");
  font-weight: 800;
  font-style: italic;
}

@font-face {
  font-family: "AvenirNextLTPro";
  src: url(${AvenirNextLTProUltlt}) format("truetype");
  font-weight: 900;
  font-style: normal;
}

@font-face {
  font-family: "AvenirNextLTPro";
  src: url(${AvenirNextLTProUltLtIt}) format("truetype");
  font-weight: 900;
  font-style: italic;
}
`;
